// returns whether a node is an at-rule
export default (node) => node && node.type === 'atrule';
